// extracted by mini-css-extract-plugin
export var downArrow = "_91-0";
export var label = "_91-1";
export var treatmentCard = "_91-3";
export var upArrow = "_91-2";